var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFileIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 16,
    viewBox: "0 0 12 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.33341 7.33333H3.33341M4.66675 10H3.33341M8.66675 4.66667H3.33341M11.3334 4.53333V11.4667C11.3334 12.5868 11.3334 13.1468 11.1154 13.5746C10.9237 13.951 10.6177 14.2569 10.2414 14.4487C9.81357 14.6667 9.25352 14.6667 8.13341 14.6667H3.86675C2.74664 14.6667 2.18659 14.6667 1.75877 14.4487C1.38244 14.2569 1.07648 13.951 0.884735 13.5746C0.666748 13.1468 0.666748 12.5868 0.666748 11.4667V4.53333C0.666748 3.41323 0.666748 2.85317 0.884735 2.42535C1.07648 2.04903 1.38244 1.74307 1.75877 1.55132C2.18659 1.33333 2.74664 1.33333 3.86675 1.33333H8.13341C9.25352 1.33333 9.81357 1.33333 10.2414 1.55132C10.6177 1.74307 10.9237 2.04903 11.1154 2.42535C11.3334 2.85317 11.3334 3.41323 11.3334 4.53333Z",
    stroke: "#667085",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFileIcon);
export default __webpack_public_path__ + "static/media/file_icon.728bae5b03dbe6dc31b1c1f10d510c5b.svg";
export { ForwardRef as ReactComponent };